// extracted by css-extract-rspack-plugin
export default {"arrowRight":"wGvng"};